import { combineReducers } from 'redux'
import theme from './themeStore'
import email from '../../components/my-email/redux/emailStore'
import jobsreducer from "../../components/jobs-email/redux/reducer";
import  billReducer from "../../components/vendors/redux/billReducer"

export default combineReducers({ theme, email ,jobsreducer,billReducer})
